import { render, staticRenderFns } from "./drugs.vue?vue&type=template&id=353de587&"
import script from "./drugs.vue?vue&type=script&lang=js&"
export * from "./drugs.vue?vue&type=script&lang=js&"
import style0 from "./drugs.vue?vue&type=style&index=0&id=353de587&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports